import { createSignal, Show, type JSX } from 'solid-js'
import { ViewSlot, type ViewProps } from 'wdc-cube-solid'
import type { RestrictedScope } from 'mormaii-web-presentation/restricted'

import { Header, Sidebar } from '../../components/shell'

import Css from './restricted.module.scss'

/**
 * O HUB: barra, cabecalho e a tela de dentro no slot.
 *
 * Nao nomeia nenhuma tela. O `content` e resolvido pelo `ViewFactory` a partir do
 * scope que o presenter de dentro publicou - desenhar uma tela e registrar a view
 * dela, nao editar este arquivo.
 *
 * ## A gaveta fica AQUI, e nao num place
 *
 * Se o menu esta aberto e estado de componente, como no renderizador React: abrir o
 * menu nao e um lugar onde o leitor esta, e ninguem manda a um colega o link de uma
 * barra aberta. Tudo o mais - filtro, pagina, ordenacao - e parametro de place.
 *
 * ## A altura travada, e o que ela quebrava
 *
 * A casca ocupa UMA tela e rola por dentro. No papel isso recorta: a Base de
 * Usuarios chama `window.print()`, e com `h-dvh` o navegador so tem uma tela para
 * imprimir - foram 900px de papel para 3.368px de conteudo, medido nos dois
 * paineis. Os `print:` soltam altura e overflow so na impressao, e nao mudam um
 * pixel da tela.
 */
export function RestrictedView(props: ViewProps<RestrictedScope>): JSX.Element {
    const [menuOpen, setMenuOpen] = createSignal(false)

    return (
        <div class={Css.shell}>
            <Sidebar groups={props.scope.navigation} open={menuOpen()} onClose={() => setMenuOpen(false)} />

            <div class={Css.column}>
                <Header
                    title={props.scope.sectionTitle}
                    subtitle={props.scope.sectionSubtitle}
                    icon={props.scope.sectionIcon}
                    userName={props.scope.userName}
                    roleLabel={props.scope.roleLabel}
                    identityLoading={props.scope.identityLoading}
                    companySelector={props.scope.companySelector}
                    themes={props.scope.themes}
                    onOpenMyData={() => void props.scope.onOpenMyData()}
                    onSignOut={() => void props.scope.onSignOut()}
                    onOpenMenu={() => setMenuOpen(true)}
                />

                <main class={Css.content}>
                    {/*
                        Sem conteudo AINDA e area vazia, pelo mesmo motivo da casca: a
                        secao chega um instante depois do cabecalho, e um aviso de erro
                        naquele intervalo apareceria em toda troca de tela.
                    */}
                    <Show when={props.scope.content}>
                        {(content) => <ViewSlot scope={content()} fallback={<CannotOpen />} />}
                    </Show>
                </main>
            </div>
        </div>
    )
}

/**
 * A secao nao pode ser desenhada - e, como na casca, isso e DEFEITO.
 *
 * Fica no lugar do conteudo, com a barra e o cabecalho de pe em volta, e por isso
 * nao precisa de botao: o menu ao lado esta ali. Ver a nota gemea em `v-main.tsx`
 * sobre por que o texto deixou de prometer "desenho a seguir".
 */
function CannotOpen(): JSX.Element {
    console.error('[views] Nenhuma view para a seção aberta - endereço inválido ou scope sem view registrada')

    return (
        <div class={Css.cannotOpen}>
            <span class={Css.cannotOpenIcon}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <path d="M4 5h16v14H4zM4 9h16M9 9v10" stroke-linejoin="round" />
                </svg>
            </span>
            <p class={Css.cannotOpenTitle}>Não foi possível abrir esta tela</p>
            <p class={Css.cannotOpenText}>
                O endereço pode ser antigo, ou a tela pode ter mudado de lugar. Escolha uma seção no menu ao lado.
            </p>
        </div>
    )
}
